import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
export const formatUTCDate = (date) => {
    return format(utcToZonedTime(new Date(date), "UTC"), "MM/dd/yy");
};
export default formatUTCDate;
